/**
 * Table Row Component
 * 
 * @package TopBuddy
 */

import { __ } from '@wordpress/i18n';
import ActiveToggle from './ActiveToggle';

const TableRow = ({ post, isActive, isPro, onToggle, onDelete, onDuplicate }) => {
	const statusLabels = {
		publish: __('Published', 'topbuddy'),
		draft: __('Draft', 'topbuddy'),
	};

	const statusClass = post.status === 'publish' ? 'status-publish' : 'status-draft';

	const handleDelete = (e) => {
		e.preventDefault();
		onDelete(post.id);
	};

	const handleDuplicate = (e) => {
		e.preventDefault();
		if (onDuplicate) {
			onDuplicate(post.id);
		}
	};

	return (
		<tr>
			<td className="topbuddy-table-title">
				<strong>
					<a href={post.editLink} className="row-title">
						{post.title || __('(no title)', 'topbuddy')}
					</a>
				</strong>
				<div className="row-actions">
					<span className="edit">
						<a href={post.editLink}>{__('Edit', 'topbuddy')}</a> |{' '}
					</span>
					<span className="duplicate">
						<a href="#" onClick={handleDuplicate}>
							{__('Duplicate', 'topbuddy')}
						</a> |{' '}
					</span>
					<span className="trash">
						<a href="#" onClick={handleDelete} className="submitdelete">
							{__('Delete', 'topbuddy')}
						</a>
					</span>
				</div>
			</td>
			<td className="topbuddy-table-status">
				<span className={`topbuddy-status-badge ${statusClass}`}>
					{statusLabels[post.status] || post.status}
				</span>
			</td>
			<td className="topbuddy-table-active">
				<ActiveToggle
					postId={post.id}
					isActive={isActive}
					isPro={isPro}
					onToggle={onToggle}
				/>
			</td>
		</tr>
	);
};

export default TableRow;

